var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6824 38.0195C30.1514 38.0195 37.8276 30.3433 37.8276 20.8742C37.8276 11.4052 30.1514 3.729 20.6824 3.729C11.2133 3.729 3.53711 11.4052 3.53711 20.8742C3.53711 30.3433 11.2133 38.0195 20.6824 38.0195ZM30.455 10.107L22.6741 19.1515L31.1362 31.4671H24.9125L19.2137 23.1738L12.0791 31.4671H10.2353L18.3952 21.9825L10.2353 10.107H16.459L21.8551 17.9602L28.6111 10.107H30.455ZM19.3219 20.9045L20.1487 22.0871L25.7799 30.1422H28.6121L21.7112 20.2714L20.8846 19.0889L15.5758 11.4951H12.7436L19.3219 20.9045Z",
    fill: "#AAC7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.7f75cc1cc58108e7a3e45133822b2d53.svg";
export { ForwardRef as ReactComponent };